<mat-tab-group animationDuration="0ms" >
    <ng-container *ngFor="let sectionArticle of sectionArticles;">
        <mat-tab label="{{sectionArticle.sectionDescription}}">
            <ng-template matTabContent>
                <csl-country-panel [countryNewsArticles]="sectionArticle.newsArticles"></csl-country-panel>
            </ng-template>
        </mat-tab>
    </ng-container>
</mat-tab-group>